import { ApiTransport } from "./ApiTransport";
import { saveNetworkResult } from "../helpers/SaveNetworkCalls";

const SIMULATED_LATENCY_MS = 400;

/**
 * Drop-in `IApiTransport` for local/offline work (`?mock=1`) — same option
 * builders as `ApiTransport`, but `makeAPICall` resolves the fixture given
 * at construction time instead of hitting the network. Generic across
 * chart types: each service supplies its own fixture, so this class has no
 * knowledge of any particular dataset.
 */
class MockApiTransport<T = unknown> extends ApiTransport {
  constructor(private readonly fixture: T) {
    super();
  }

  override makeAPICall<TResponse = T>(url: string, requestObject?: RequestInit): Promise<TResponse> {
    return new Promise((resolve) => {
      setTimeout(() => {
        saveNetworkResult("apiCall", "mockNetworkCall", url, requestObject, this.fixture);
        resolve(this.fixture as unknown as TResponse);
      }, SIMULATED_LATENCY_MS);
    });
  }
}

export { MockApiTransport };
